<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-checkbox
            outlined
            flat
            dense
            background-color="white"
            v-model="invoice"
            label="Invoice"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="8">
          <v-file-input
            v-model="files"
            label="File"
            accept=".pdf"
            prepend-icon="mdi-file-pdf-box"
            placeholder="Upload PDF File"
            outlined
            dense
            clearable
            multiple
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="2">
          <v-btn @click="uploadFile" color="success">
            <v-icon>
              mdi-file-upload
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import fileDownload from "js-file-download";

export default {
  name: "report-rename-pdf",
  data() {
    return {
      invoice: true,
      files: [],
    };
  },
  methods: {
    async uploadFile() {
      const formData = new FormData();
      this.files.forEach(file => {
        formData.append("files", file);
      });

      this.$store.commit("SET_LOADER", true);
      await this.$store
        .dispatch("purchaseInvoice/rename", { body: formData, params: { invoice: this.invoice } })
        .then(response => {
          fileDownload(
            response.data,
            this.invoice ? "report-rename-invoice.zip" : "report-rename-tax.zip"
          );
          this.$store.commit("SET_LOADER", false);
        })
        .catch(() => {
          this.$store.dispatch("toast", {
            type: "error",
            message: "Ada masalah dengan aplikasi, mohon hubungi admin aplikasi",
          });
          this.$store.commit("SET_LOADER", false);
        });
    },
  },
};
</script>

<style scoped></style>
